// extracted by mini-css-extract-plugin
export var TopPageLink = "styles-module--TopPageLink--3dRo2";